/** @jsxImportSource react */

import { DataPoints } from '@sly/core/api/types';
import { formatMoney } from '@sly/core/src/helpers/numbers';

interface CostGraphicProps {
  dataPoints: DataPoints;
  avg: number;
  city: string;
  careType: string;
}

const CostGraphic = ({ dataPoints, avg, careType, city }: CostGraphicProps) => {
  let percentage =
    ((avg - Number(dataPoints.minPrice)) /
      (Number(dataPoints.maxPrice) - Number(dataPoints.minPrice))) *
    100;

  if (percentage < 0 || percentage > 100) {
    return null;
  }

  if (percentage > 100) {
    percentage = 100;
  }

  return (
    <div>
      <div className='font-t-xs-azo mb-16'>
        The average price of these communities is{' '}
        <span className='text-green-base'>
          {formatMoney(Math.abs(Number(dataPoints.maxPrice) - avg))} lower
        </span>{' '}
        than the maximum price of similar {careType} communities in {city}
      </div>
      <div className='relative flex flex-row items-center gap-1'>
        <div
          style={{ left: `${percentage - 5}%`, bottom: '15px' }}
          className='absolute rounded-lg border border-black bg-white p-1'
        >
          {formatMoney(avg)}
        </div>
        <div
          style={{ left: `${percentage}%` }}
          className='absolute h-3 w-3 rounded-full border-2 border-black bg-white'
        ></div>
        <div className='h-1 w-1/6 rounded bg-green-lighter-40' />
        <div className='h-1 w-2/3 rounded bg-yellow-lighter-40' />
        <div className='h-1 w-1/6 rounded bg-red-lighter-40' />
      </div>
      <div className='font-t-xxs-azo mt-1 flex flex-row justify-between'>
        <div>{formatMoney(dataPoints.minPrice)}</div>
        <div>{formatMoney(dataPoints.maxPrice)}</div>
      </div>
    </div>
  );
};

export default CostGraphic;
